import { FC } from 'react';
import { FormBehavior } from '~/modules';
import ModalCreateNotification from './ModalCreateNotification';
import { initialValues, validationSchema } from './schema';

type Props = {
  isOpen: boolean;
  handleClose(): void;
  handleFormSubmit(values: CreatePushNotificationParams): void;
};

const ModalCreateNotificationContainer: FC<Props> = ({
  isOpen,
  handleClose,
  handleFormSubmit,
}) => (
  <FormBehavior
    validationSchema={validationSchema}
    initialValues={initialValues}
    onSubmit={handleFormSubmit}
  >
    <ModalCreateNotification isOpen={isOpen} handleClose={handleClose} />
  </FormBehavior>
);

export default ModalCreateNotificationContainer;
